import React, { useState } from 'react';
import Icon from 'components/Icon';
import Text from 'components/Text';
const LanguageDropdown = (props) => {
    const [isOpened, isOpenedUpdater] = useState(false);
    return (React.createElement("div", { className: `language-dropdown ${isOpened ? 'opened' : 'closed'}`, onClick: () => isOpenedUpdater(!isOpened), "data-testid": "language-dropdown" },
        React.createElement(Icon.Base, { icon: "arrow-down" }),
        " ",
        React.createElement(Text.Base, null, props.selection.toUpperCase()),
        isOpened && (React.createElement("div", { className: "content language" },
            props.title && React.createElement(Text.Small, { color: "white" }, props.title),
            React.createElement("div", { className: "options" },
                React.createElement("div", { className: "close", onClick: () => isOpenedUpdater(!isOpened) },
                    React.createElement(Icon.Base, { icon: "close" })),
                props.options.map((option) => (React.createElement("span", { key: option.value, onClick: () => {
                        props.onSelect(option.value);
                        isOpenedUpdater(false);
                    } }, props.selection === option.value ? (React.createElement(Text.Small, { color: "yellow" }, option.title)) : (React.createElement(Text.Small, { color: "white" }, option.title))))))))));
};
export default LanguageDropdown;
